import { FC, MutableRefObject } from "react";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import UtenteMaster from "../../../../interfaces/utenteMaster";
import columnsHandler from "../columns";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";

interface UsersDataGridProps {
  gridApiRef: MutableRefObject<GridApiPremium>;
  userList: {
    currentPage: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
    users: UtenteMaster[];
  };
  page: number;
  onPageChange: (currentPage: number) => void;
  onRowClick: (utente: UtenteMaster) => void;
  selectedUtente: UtenteMaster | null;
}

const UsersDataGrid: FC<UsersDataGridProps> = ({
  gridApiRef,
  userList,
  page,
  onPageChange,
  onRowClick,
  selectedUtente,
}) => {
  return (
    <DataGridPremium
      apiRef={gridApiRef}
      columns={columnsHandler()}
      rows={!!userList ? userList.users : []}
      hideFooterSelectedRowCount
      rowsPerPageOptions={[!!userList ? userList.pageSize : 10]}
      paginationMode="server"
      rowCount={!!userList ? userList.totalItems : 0}
      page={page}
      onPageChange={(page) => onPageChange(page)}
      onRowClick={(params) => onRowClick(params.row as UtenteMaster)}
      getRowClassName={(params) =>
        selectedUtente && params.id === selectedUtente.id ? "selected-row" : ""
      }
      sx={{
        "& .MuiDataGrid-cell": {
          outline: "none!important",
        },
        "& .MuiInputBase-root": {
          border: "none!important",
        },
        "& .selected-row": {
          backgroundColor: "rgba(0, 0, 255, 0.04)",
        },
        mt: 1,
      }}
    />
  );
};

export default UsersDataGrid;
